import { render, staticRenderFns } from "./VirtualAPI.vue?vue&type=template&id=01a2908c"
import script from "./VirtualAPI.vue?vue&type=script&lang=js"
export * from "./VirtualAPI.vue?vue&type=script&lang=js"
import style0 from "./VirtualAPI.vue?vue&type=style&index=0&id=01a2908c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports